import {
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableContainer,
    Tooltip
} from "@material-ui/core";
import React, { ReactElement } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { globalStyles } from "../../../assets/globalStyles";
import { useStyles } from "./pqIndexStyle";
import { updateSelectedTabAll, selectAktuellerGrenzwertsatzTemp, selectSelectedTab } from "./pqIndexSlice";
import ColorValues from "./colorTableCell";
import { colNameType, pqIndexResult } from "./pqIndexTypes";
import { kenngroesse } from "../../../utils/apiTypes";
import { selectKenngroesseWert } from "../../../features/filter/kenngroesseSlice";
import { selectMessstelleWert, selectSliderTemp } from "../../../features/filter/messstellenFilterSlice";
import { selectEndeDatum, selectStartDatumTemp } from "../../../features/filter/zeitSlice";
import { getKenngroesseDetailZeit, selectKenngroesseDetailZeit } from "./kenngroesseDetailTableSlice";
import {
    selectKenngroesseMinKenngroesseListe, selectKenngroesseMinZeitAll, selectKenngroesseMinZeitListe, selectKenngroesseZeit,
    selectKenngroesseZeitListe
} from "./kenngroesseGruppeZeitTableSlice";
import LegendePQIndex from "./legendePQIndex";

export default function KenngroesseZeitGrid(): ReactElement {

    const dispatch = useAppDispatch();
    const classes = {

        ...globalStyles(),
        ...useStyles()
    };

    const kenngroesseZeit = useAppSelector(selectKenngroesseZeit);
    const kenngroesseDetailZeit = useAppSelector(selectKenngroesseDetailZeit)
    const kwListe = useAppSelector(selectKenngroesseZeitListe);
    const minKenngroesseListe = useAppSelector(selectKenngroesseMinKenngroesseListe);
    const minZeitListe = useAppSelector(selectKenngroesseMinZeitListe);
    const minValueAll = useAppSelector(selectKenngroesseMinZeitAll);

    const grenzwertsatz = useAppSelector(selectAktuellerGrenzwertsatzTemp);
    const pqIndexSlider = useAppSelector(selectSliderTemp);
    const startDatum = useAppSelector(selectStartDatumTemp);
    const endeDatum = useAppSelector(selectEndeDatum);

    const kenngroesseFilterWertCommitted = useAppSelector(selectKenngroesseWert);
    const messstelleFilterWertCommitted = useAppSelector(selectMessstelleWert);

    const selectedTab = useAppSelector(selectSelectedTab);

    function openKenngroesseDetailZeitGrid(kenngroesseKategorie: string) {

        const kenngroesseListe: kenngroesse[] = []
        let isInMessstelleKenngroesseList = false;

        kenngroesseFilterWertCommitted.forEach(kenngroesseEleme => {
            if (kenngroesseEleme.pqIndexKategorie == kenngroesseKategorie) {
                kenngroesseListe.push(kenngroesseEleme)
            }
        })

        for (let index = 0; index < kenngroesseDetailZeit.length; index++) {
            // eslint-disable-next-line security/detect-object-injection
            if (kenngroesseKategorie == kenngroesseDetailZeit[index].kenngroesse) {
                isInMessstelleKenngroesseList = true;
            }
        }
        if (!isInMessstelleKenngroesseList) {
            dispatch(getKenngroesseDetailZeit(messstelleFilterWertCommitted, kenngroesseListe, startDatum, endeDatum, pqIndexSlider[0], pqIndexSlider[1], grenzwertsatz, true, false, kenngroesseKategorie));
            dispatch(updateSelectedTabAll(kenngroesseKategorie + "zeit", selectedTab));
        }
    }

    function createTableCell(kwElem: colNameType, rows: pqIndexResult[]) {
        const rowsMaxIndex = rows.length
        let rowsIndex = 0;
        const cellValue = 11;
        while (rowsMaxIndex > rowsIndex) {
            // eslint-disable-next-line security/detect-object-injection
            if (kwElem.col == rows[rowsIndex].col) {
                // eslint-disable-next-line security/detect-object-injection
                return (<ColorValues value={rows[rowsIndex].value} />)
            }
            rowsIndex += 1;
        }
        return (<ColorValues value={cellValue} />)
    }

    return (
        <React.Fragment>
            <Grid item md={12} style={{ textAlign: 'left', marginRight: "20px" }}>
                <div >
                    <LegendePQIndex />
                    <TableContainer component={Paper} style={{ height: '80vh' }}>
                        <Table aria-label="simple table" className={classes.table}>
                            <TableHead>
                                <TableCell className={classes.tableHeaderHorizontalLeftmost}>Kenngrößenkategorie / KW</TableCell>
                                {kwListe.map((elem, index) => (
                                    <TableCell key={index} className={classes.tableHeaderHorizontal}>{elem.name}</TableCell>
                                ))}
                                <TableCell className={classes.tableHeaderHorizontalBlank} style={{ width: "20px" }} />
                                <TableCell className={classes.tableHeaderHorizontal}>Alle Kenngrößenkategorien</TableCell>
                            </TableHead>
                            <TableBody>
                                {kenngroesseZeit.map((rows, index) => (
                                    <TableRow key={rows[0].row} >
                                        <Tooltip title="Zeige die Werte für die dazugehörigen Kenngrößen.">
                                            <TableCell
                                                style={{ cursor: "pointer" }}
                                                className={classes.tableHeaderVerticalClickable}
                                                component="th"
                                                scope="rows"
                                                onClick={() => (
                                                    openKenngroesseDetailZeitGrid(rows[0].row)
                                                )}
                                            >{rows[0].row}</TableCell>
                                        </Tooltip>
                                        {kwListe.map(elem => (
                                            createTableCell(elem, rows)
                                        ))}
                                        <TableCell className={classes.tableCellBlank} style={{ width: "20px" }} />
                                        {/* eslint-disable-next-line security/detect-object-injection */}
                                        <ColorValues value={minKenngroesseListe[index]} />
                                    </TableRow>
                                ))}
                                <TableRow >
                                    <TableCell />
                                </TableRow>
                                <TableRow >
                                    <TableCell style={{ width: "295px" }} component="th" scope="rows" className={classes.tableHeaderVertical}>Gesamte Zeit</TableCell>
                                    {minZeitListe.map((elem, index) => (
                                        <ColorValues value={elem} key={index} />
                                    ))}
                                    <TableCell className={classes.tableCellBlank} style={{ width: "20px" }} />
                                    <ColorValues value={minValueAll} />
                                </TableRow>

                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </Grid>
        </React.Fragment>
    );
}

